var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalRenommerCommande",
      attrs: {
        size: "md",
        title: "Renommer une commande",
        "ok-title": "Renommer",
        "ok-disabled":
          !_vm.$v.nouveauNom.required || !_vm.$v.nouveauNom.minLength,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.initialiserModale()
        },
        shown: function($event) {
          return _vm.$refs.nouveauNomCommande.focus()
        },
        ok: function($event) {
          return _vm.renommerCommande()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "nouveauNomCommande" } }, [
            _vm._v("Nom de la commande")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.nouveauNom,
                expression: "nouveauNom",
                modifiers: { trim: true }
              }
            ],
            ref: "nouveauNomCommande",
            staticClass: "form-control",
            attrs: { type: "text", id: "nouveauNomCommande", maxlength: "80" },
            domProps: { value: _vm.nouveauNom },
            on: {
              focus: function($event) {
                return $event.target.select()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.nouveauNom = $event.target.value.trim()
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          !_vm.$v.nouveauNom.required
            ? _c("div", { staticClass: "error" }, [
                _vm._v("Ce champ est requis")
              ])
            : _vm._e(),
          !_vm.$v.nouveauNom.minLength
            ? _c("div", { staticClass: "error" }, [
                _vm._v("Ce champ doit contenir au moins 3 caractères")
              ])
            : _vm._e()
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }